export default "__VITE_ASSET__DlZXR2dI__"